(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reel-section"] && !Shopify.designMode) return;
  try {
    
const wrapper = document.querySelector('.reels-wrapper') || null;
const prevBtn = document.querySelector('.reels-btn.prev');
const nextBtn = document.querySelector('.reels-btn.next');
const cardWidth = 280;

// Scroll buttons
if (prevBtn && nextBtn && wrapper) {
  prevBtn.addEventListener('click', () => {
    wrapper.scrollBy({ left: -cardWidth, behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', () => {
    wrapper.scrollBy({ left: cardWidth, behavior: 'smooth' });
  });
}

// Drag support
let isDown = false;
let startX;
let scrollLeft;
wrapper.addEventListener('mousedown', (e) => {
  isDown = true;
  startX = e.pageX - wrapper.offsetLeft;
  scrollLeft = wrapper.scrollLeft;
});
wrapper.addEventListener('mouseleave', () => isDown = false);
wrapper.addEventListener('mouseup', () => isDown = false);
wrapper.addEventListener('mousemove', (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - wrapper.offsetLeft;
  const walk = (x - startX) * 1.2;
  wrapper.scrollLeft = scrollLeft - walk;
});

// Helper to play videos that are currently visible
function playVisibleVideos() {
  document.querySelectorAll('.reel-card').forEach(card => {
    const rect = card.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    const video = card.querySelector('video');
    if (isVisible && video && video.paused && video.src) {
      video.play().catch(() => {});
    }
  });
}

// MODAL LOGIC
document.querySelectorAll('.reel-card').forEach((card) => {
  card.addEventListener('click', () => {
    const modal = document.getElementById('reelModal');
    const modalVideo = document.getElementById('modalVideo');
    const videoInCard = card.querySelector('video');

    // Get video source from the card's video element
    const videoSrc = videoInCard ? videoInCard.dataset.src : null;
    if (!videoSrc) return;

    // Pause all background videos
    document.querySelectorAll('.reel-video').forEach(video => {
  video.pause();
});

    // Set modal video source and play
    modalVideo.src = videoSrc;
    modalVideo.muted = true;
    modalVideo.play().then(() => {
      modalVideo.muted = false;
    }).catch(err => console.warn('Modal video play error:', err));

    // Fill product details
    document.getElementById('modalProductTitle').innerText = card.dataset.productTitle;
    document.getElementById('modalProductPrice').innerText = card.dataset.productPrice;
    document.getElementById('modalProductImage').src = card.dataset.productImage;
    document.getElementById('modalProductBtn').href = card.dataset.productUrl;

    modal.classList.add('active');
  });
});

// CLOSE MODAL
document.getElementById('reelClose').addEventListener('click', () => {
  const modal = document.getElementById('reelModal');
  const modalVideo = document.getElementById('modalVideo');
  modalVideo.pause();
  modalVideo.src = '';
  modal.classList.remove('active');

  // Resume any videos that are now visible
  playVisibleVideos();
});


/* LOAD AND AUTOPLAY ALL REEL VIDEOS */

function initReelVideos() {
  document.querySelectorAll('.reel-video').forEach(video => {

    if (!video.src) {
      video.src = video.dataset.src;
      video.load();
    }

    video.muted = true;
    video.play().catch(() => {});
  });
}

/* RUN AFTER PAGE LOAD */
window.addEventListener('load', initReelVideos);

  } catch(e) { console.error(e); }
})();
})();
